import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CecService } from 'src/app/core/services/cec.service';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PosWarningsComponent } from 'src/app/modal/pos-warnings/pos-warnings.component';
import { MsalService } from '@azure/msal-angular';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'dq-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  filtersVisible$!: Observable<boolean>;
  posWarningsCount$!: Observable<Number>;
  btnClass: string = '';
  userName: string = '';

  constructor(
    private dataService: DataService,
    private cecService: CecService,
    private modalService: NgbModal,
    private changeDetector: ChangeDetectorRef,
    private msalService: MsalService
  ) {

    this.dataService.getTokenSAP$().subscribe((token) => {
      if (token != null) {
        this.dataService.getUserSSO$().subscribe((me) => {
          console.log(me)
          if (me) {
            this.cecService.getUserSapIds().subscribe((result) => {
              // Check if user is TAM, we will use SAP_ID in order to filter
              const { SAP_ID } =
                result.value.find((u: any) => u.EMAIL === me?.email) || {};
              SAP_ID && console.log('---------- SAP', SAP_ID);
              try {
                this.userName = (me?.firstName || me?.lastName)
                  ? `${me.firstName || ''} ${me.lastName || ''}`.trim()
                  : (me?.name || '');
                const auxUserName = me?.username || '';

                //Nueva funcionalidad de verificar adm
                console.log('---------- is admin', me?.isManager);
                if (me?.isManager === false) {
                  SAP_ID && this.dataService.setSapId(SAP_ID); // If is not admin and sap id exists, set sap_id
                } else {
                  this.dataService.setSapId('');
                }

                this.dataService.setResultFromMembers(me?.isManager ? true : false);
                this.dataService.setUserInfo(me);

                // this.cecService.getIsAdmin(auxUserName).subscribe(
                //   (result) => {
                //     console.log('---------- is admin', result);
                //     if (result === false) {
                //       SAP_ID && this.dataService.setSapId(SAP_ID); // If is not admin and sap id exists, set sap_id
                //     } else {
                //       this.dataService.setSapId('');
                //     }

                //     this.dataService.setResultFromMembers(result ? true : false);
                //     this.dataService.setUserInfo(me);
                //   },
                //   (error) => {
                //     // Not an admin
                //     SAP_ID && this.dataService.setSapId(SAP_ID); // If sap_id exists, set sap_id
                //     this.dataService.setResultFromMembers(false);
                //     this.dataService.setUserInfo(me);
                //   }
                // );
              } catch (ex) {
                this.userName = 'error';
              }
            });
          }

        });
      }
    });

    // this.dataService.getTokenSAP$().subscribe((token) => {
    //   if (token != null) {
    //     this.cecService.getUserName().subscribe((me) => {
    //       this.cecService.getUserSapIds().subscribe((result) => {
    //         // Check if user is TAM, we will use SAP_ID in order to filter
    //         const { SAP_ID } =
    //           result.value.find((u: any) => u.EMAIL === me.email) || {};
    //         SAP_ID && console.log('---------- SAP', SAP_ID);
    //         try {
    //           this.userName = me.firstName + ' ' + me.lastName;
    //           this.cecService.getIsAdmin(me.userName).subscribe(
    //             (result) => {
    //               console.log('---------- is admin', result);
    //               if (result === false) {
    //                 SAP_ID && this.dataService.setSapId(SAP_ID); // If is not admin and sap id exists, set sap_id
    //               } else {
    //                 this.dataService.setSapId('');
    //               }

    //               this.dataService.setResultFromMembers(result ? true : false);
    //               this.dataService.setUserInfo(me);
    //             },
    //             (error) => {
    //               // Not an admin
    //               SAP_ID && this.dataService.setSapId(SAP_ID); // If sap_id exists, set sap_id
    //               this.dataService.setResultFromMembers(false);
    //               this.dataService.setUserInfo(me);
    //             }
    //           );
    //         } catch (ex) {
    //           this.userName = 'error';
    //         }
    //       });
    //     });
    //   }
    // });
  }

  ngOnInit(): void {
    this.filtersVisible$ = this.dataService.getFiltersVisible$();
    this.dataService.getUserInfo$().subscribe((userInfo) => {
      if (userInfo != null) {
        this.dataService.sendRefreshPosWarningsCount();
        this.posWarningsCount$ = this.dataService.getCountPosWarnings$();
      }
    });
    this.filtersVisible$.subscribe((visible) =>
      visible ? (this.btnClass = '') : (this.btnClass = 'btn-filtros-disabled')
    );
  }

  showhideFilters() {
    this.dataService.sendShowHideFilters();
  }

  showModalWarnings() {
    this.showhideFilters();
    const modalRef = this.modalService.open(PosWarningsComponent);
    this.changeDetector.detectChanges();
  }

  isDetail() {
    return this.dataService.isDetail();
  }

  logout() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.azure.redirectUriLogout
    });
  }
}
